import cx from 'classnames';

type Props = {
  colorScheme?: 'white' | 'light' | 'dark';
  children: React.ReactNode;
  gap?: string;
};

const SectionWrapper = ({
  colorScheme = 'white',
  children,
  gap = 'lg:gap-8',
}: Props) => {
  const theme = {
    white: 'color-scheme-white',
    light: 'color-scheme-light',
    dark: 'color-scheme-dark',
  }[colorScheme];

  return (
    <div
      data-testid="storefront-row"
      className={cx(
        'relative max-w-7xl shrink-0 justify-center lg:grid lg:grid-cols-12 xl:w-full',
        'mx-4 my-16 md:mx-6 md:my-20 lg:mx-16 lg:my-24 xl:mx-auto xl:my-32',
        'bg-surface p-8 lg:p-16',
        gap,
        theme,
        colorScheme === 'white' && '',
        colorScheme === 'dark' && 'rounded-md',
        colorScheme === 'light' && 'rounded-md',
      )}
    >
      {children}
    </div>
  );
};

export default SectionWrapper;
